import * as R from 'ramda';
import { BuildingGranulometry } from '../BuildingGranulometry';
import { getCaseParkingSectionsCount } from '../../cases/queries/sections/counts/getCaseParkingSectionsCount';

export const getBuildingParkingsCount = (buildingGranulometry: BuildingGranulometry): number =>
  R.sum(buildingGranulometry.cases.map(getCaseParkingSectionsCount));
